// File: cgp-notification-menu.module.ts
// Author: Brandon Shreve
// Date: 10/25/2018
// Desc: Menu to display notifications
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { CgpNotificationMenuComponent } from './cgp-notification-menu.component';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatMenuModule
    ],
    exports: [
        CgpNotificationMenuComponent
    ],
    declarations: [
        CgpNotificationMenuComponent
    ],
    providers: []
})
export class CgpNotificationMenuModule { }